"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgAreaAlt2(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "2 0 19 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.844 4.1l-5.238 7.34a2.001 2.001 0 00.016 2.345l4.112 5.603.063.081.039.047a2 2 0 002.82.2l3.396-2.947 5.407 1.37a1.998 1.998 0 002.462-2.278l-1.598-9.252a1.998 1.998 0 00-2.538-1.577l-1.934.572-4.521-2.148a2 2 0 00-2.486.645zm-3.61 8.502l5.238-7.34 4.52 2.148c.446.212.953.252 1.426.112l1.934-.573 1.599 9.252-5.408-1.37a2 2 0 00-1.802.428l-3.395 2.946-4.112-5.603z" })));
}
exports.default = tombacIcon_1.default('AreaAlt2')(SvgAreaAlt2);
//# sourceMappingURL=AreaAlt2.js.map